import { BrandDetail } from "@infra/models/Brands"
import { CirculationPlaceItem } from "@infra/models/CirculationPlace"

export class RequestResponse {
  id: string = ""
  mensaje: string = ""
}

export class VehicleGroup {
  id? = null
  grupoId: number | null = null
  modeloVehiculoId? = null
  marcaVehiculoId? = null
  claseVehiculoId? = null
  tipoVehiculoId? = null
  usoVehiculoId? = null
  minAsientos? = null
  maxAsientos? = null
  tipoRegla? = null
}

export class ModelInfo {
  codModelo: string | null = null
  descModelo: string | null = null
  codModeloApeseg: string | null = null
  descModeloStd: string | null = null
  descCategoriaMtc: string | null = null
}

export class ModelDetailPlate {
  placa: string | null = null
  ano: number | null = null
  numMotor? = ""
  numSerieChasisMotor = ""
  tipoRie? = ""
  tipoVeh = ""
  descTipoVeh = ""
  claseVeh: string | null = null
  descClaseVeh = ""
  codUso = ""
  descUso = ""
  cantAsiento: number | null = null
  marcas: BrandDetail = new BrandDetail()
  modelo: ModelInfo = new ModelInfo()
}

export class Quote {
  solicitudId = ""
  precio = 0
  precioRenovacion = 0
  priceFinal = 0
  tarifa: number | null = null
  tarifaRenovacion: number | null = null
  numSecuencial: number | null = null
  fechaFinCoverturaApeseg: string | null = null
  fechaFinCovertura: string | null = null
  selectedPlanType: number | null = null
  fechaInicioVigencia = ""
  fechaInicioCovertura = ""
  flagErrorApeseg?: boolean | null = null
  sessionKey? = ""
  jobId? = ""
  precioAutoEfectivo?: number | null = 0.0
  precioMesAutoEfectivo?: number | null = 0.0
  flagGps?: boolean | null = null
  montoCoberturaRobo?: number | null = 0
  selectedVidaDevolucion?: boolean | null = false
  autoEfectivoTotalPrice?: number | null = 0
  autoEfectivoJobId?: string | null = ""
}

export class ChannelProductUrlResponse {
  canalId: number | null = 0
  nombre = ""
  url = ""
  codigoUa? = ""
  producto? = ""
  data?: Array<any> = []
}

export class ChannelResponseList {
  idCanal: string = ""
  nombre: string = ""
  codigoCanal: string = ""
  orgPrimaria: string = ""
  orgSecundaria: string = ""
  url: string = ""
  tieneVendedores: number = 0
  tarifario: string = ""
  tipoPago: number = 0
  estado: number = 0
  fechaCreacion: string = ""
  fechaModificacion: string = ""
  usuarioCreacion: string = ""
  usuarioModificacion: string = ""
}
export class CustomerResponse {
  id: number | null = null
  documentType = ""
  documentId = ""
  names = ""
  firstSurname = ""
  lastSurname = ""
  birthDate: string | null = ""
  mobile = ""
  email = ""
  ubigeo?: string | null = null
  address = ""
  nationality: string | null = ""
  gender = ""
  verified? = false
  clientType = ""
  promotional? = false
  departmentCode?: string | null = null
  provinceCode?: string | null = null
  districtCode?: string | null = null
  department: string | null = null
  province: string | null = null
  district: string | null = null
  hasBirthday? = false
}

export class PlateInfo {
  requestOk?: boolean | null = null
  vehicleInfoOk?: boolean | null = null
  circulationPlaceOk?: boolean | null = null
  vehicleGroupOk?: boolean | null = null
  customerOk?: boolean | null = null
  channelOk?: boolean | null = null
  quoteOk?: boolean | null = null
  requestResponse: RequestResponse = new RequestResponse()
  consultaVehiculoResponse: ModelDetailPlate = new ModelDetailPlate()
  circulationPlaceResponseList?: Array<CirculationPlaceItem> | null = []
  vehicleGroupResponse?: VehicleGroup = new VehicleGroup()
  fullCustomerResponse?: CustomerResponse | null = new CustomerResponse()
  channelProductUrlResponse: ChannelProductUrlResponse =
    new ChannelProductUrlResponse()
  quoteResponse?: Quote | null = new Quote()
  circulationPlaceResponse: string | null = ""
  tipoProceso?: string | null = ""
  renewal?: boolean | null = null
  flujo?: string | null = ""
  page?: string | null = ""
  action?: string | null = ""
  reload?: boolean | null = null
  derivacion?: number | null = null
  queryString?: string | null = ""
}
export class PlateResponse {
  datos: PlateInfo = new PlateInfo()
}

export class PlateVehicular {
  id?: number
  poliza: string = ""
  placa: string = ""
  fechaIniVigencia: string = ""
  fechaFinVigencia: string = ""
  codigoAseguradora: string = ""
  active?: boolean
}

export class PlateInfoResponse {
  datos: PlateVehicular[] = [new PlateVehicular(), new PlateVehicular()]
}
